export const SET_APP_USERINFO = "SET_APP_USERINFO";
export const SET_TOTAL_SUBJECTS = "SET_TOTAL_SUBJECTS";
export const SET_ANNOUNCEMENTS = "SET_ANNOUNCEMENTS";